import useToastStore from 'stores/toastStore';
import { ToastParams } from 'types/toast';

const ToastBridge = {
  add: (payload: ToastParams) => {
    useToastStore.getState().add(payload);
  },
};

export default ToastBridge;
